import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const TOKEN_KEY = "timbercut_token";

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const SERVICE_TYPES = [
  { value: "single_stump", label: "Single Stump" },
  { value: "multiple_stumps", label: "Multiple Stumps" },
  { value: "tree_trimming", label: "Tree Trimming" },
  { value: "custom", label: "Custom" },
];

export const PAYMENT_METHODS = ["Cash", "Check", "Credit Card", "Zelle", "Venmo", "Bank Transfer"];

export function serviceLabel(v) {
  return (SERVICE_TYPES.find((s) => s.value === v) || {}).label || "Service";
}

export function money(v) {
  const n = Number(v || 0);
  return n.toLocaleString("en-US", { style: "currency", currency: "USD" });
}

export function fmtDate(v) {
  if (!v) return "—";
  try {
    const d = new Date(v.length <= 10 ? v + "T00:00:00" : v);
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return v;
  }
}
